// GridComponent.js
import React, { useEffect, useState,useCallback } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PageInventaire from './Inventaire/PageInventaire';
import axios from 'axios';
import { ContextInventaire } from '../panels/Inventaire/ContextInventaire';
import PageShop from './Inventaire/PageShop';
const Inventory = ({ idPerso, token }) => {

  const [items, setItems] = useState([]);
  const [tags, setTags] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const ip = process.env.REACT_APP_IP;
  const fetchItems = useCallback(async () => {
    try {
      const responseItems = await axios.get(`${ip}/items/${idPerso}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setItems(responseItems.data);

      const responseTags = await axios.get(`${ip}/tags`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setTags(responseTags.data);

      const responseCategories = await axios.get(`${ip}/categories`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCategories(responseCategories.data);

      setIsLoading(false);
    } catch (error) {
      console.error("Une erreur s'est produite lors de la récupération des items :", error);
      setError("Une erreur s'est produite lors de la récupération des items.");
      setIsLoading(false);
    }
  }, [idPerso, ip, token]);
  useEffect(() => {
    fetchItems();
  }, [idPerso, ip, fetchItems]);

  if (isLoading) {
    return <div>Chargement...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  return (
    <div>
      <ContextInventaire.Provider value={fetchItems}>
        <Tabs>
          <TabList className={"tablist react-tabs__tab-list"}>
            {categories.map((category, index) => (
              <Tab key={index} className={"react-tabs__tab react-tabs__tab--selected2"}>{category.nomCategorie}</Tab>
            ))}
            <Tab className={"react-tabs__tab react-tabs__tab--selected2"}>Shop</Tab>
          </TabList>
          {categories.map((category, index) => (
            <TabPanel key={index}>
              <PageInventaire 
              items={items.filter(item => item.category === category.nomCategorie)} 
              category={category.nomCategorie} 
              tags={tags} 
              token={token}
              />
            </TabPanel>
          ))}

          <TabPanel>
            <PageShop tags={tags}
              categories={categories}
              token={token}
            />
          </TabPanel>
        </Tabs>
      </ContextInventaire.Provider>
    </div>
  );
};

export default Inventory;
